import { PaymentAccount, Result } from '../Api';
import axios, {
  AxiosRequestConfig,
  throwIfServerError,
} from './apiServices/apiServices';

// #region GET
export const get = async (
  config?: AxiosRequestConfig,
): Promise<PaymentAccount[] | void> => {
  try {
    const result = await axios.get<Result<PaymentAccount[]>>(
      '/Payment/PaymentAccountsV2',
      config,
    );

    return result.data.Data;
  } catch (error) {
    return throwIfServerError(error);
  }
};
// #endregion

// #region CREATE
export type CreateCardProps = {
  cardNumber: string;
  cvv: string;
  expMonth: number;
  /** expects 4 digit year (2020) */
  expYear: number;
  hasConsentToSaveCard?: boolean;
  name?: string;
  postalCode?: string;
};
/**
 * Creates new card for current user
 * @param card.expYear expects 4 digit year (2020)
 * @returns new PaymentAccountId
 */
export const createCard = async (
  card: CreateCardProps,
  config?: AxiosRequestConfig,
): Promise<number | void> => {
  try {
    const result = await axios.post<Result<number>>(
      '/Payment/CardPaymentAccount',
      card,
      config,
    );

    return result.data.Data;
  } catch (error) {
    return throwIfServerError(error);
  }
};
// #endregion

// #region DELETE
type DeleteProps = {
  paymentAccountId: number;
};
export const remove = async (
  { paymentAccountId }: DeleteProps,
  config?: AxiosRequestConfig,
) => {
  try {
    await axios.delete(
      `/Payment/PaymentAccount/?paymentAccountId=${paymentAccountId}`,
      config,
    );
  } catch (error) {
    throwIfServerError(error);
  }
};
// #endregion
